<template>
    <div id="Container_ScheduleGroupAppointmentAdd">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="$t('Shared.addgroupAppointment')" />
            </b-col>
        </b-row>

       <GroupAppointmentAdd
            ref="GroupAppointmentAdd"
            :afterSave="goBack">
       </GroupAppointmentAdd>

       <div class="space-actions"></div>
       <div class="page-actions">
             <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="goBack"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="save"
            />
       </div>
    </div>

</template>

<script>

export default {
    name: 'ScheduleGroupAppointmentAdd',

    data() {
        return {
        };
    },

    methods: {
        save() {
            this.$refs.GroupAppointmentAdd.save();
        },

        goBack() {
            this.$router.push({ name: 'ScheduleGroupAppointmentList' })
        }


    },

    created() {
    },

    mounted() {

    }
};
</script>
